import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionUpdates from './components/SectionUpdates';
import SectionCards from './components/SectionCards';
import SectionCarousel from './components/SectionCarousel';
import SectionContact from './components/SectionContact';
import SectionTopics from './components/SectionTopics';
import SectionMedia from './components/SectionMedia';
import SectionAbout from './components/SectionAbout';
import SectionRanking from './components/SectionRanking';
import SectionApp from './components/SectionApp';
import SectionFaq from './components/SectionFaq';
import SectionComments from './components/SectionComments';
import SectionFeatures from './components/SectionFeatures';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionUpdates />
        <SectionCards />
        <SectionCarousel />
        <SectionContact />
        <SectionTopics />
        <SectionMedia />
        <SectionAbout />
        <SectionRanking />
        <SectionApp />
        <SectionFaq />
        <SectionComments />
        <SectionFeatures />
      </main>
      <Footer />
    </div>
  );
}